import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Preloader from '../Preloder/Preloader';
import './Studentexam.css';

const AdminExam = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        fathername: '',
        UserId: '',
        school: '',
        medium: '',
        standard: '',
        bonafideImage: null,
        photoImage: null,
        referralId:''
    });
    const [paymentState, setPaymentState] = useState('');
    const [merchantOrderId, setMerchantOrderId] = useState('');
    const [message, setMessage] = useState('');
    const [paymentUrl, setPaymentUrl] = useState('');
    
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const OrderId = searchParams.get("orderId");

    const MediumtoStandard = {
        Tamil: ['VI', 'VII', 'VIII', 'IX', 'X', 'XI MathsBiology', 'XI Computer Science', 'XI Science', 'XI Commerce', 'XI Electrical', 'XI Civil', 'XI History', 'XII MathsBiology', 'XII Computer Science', 'XII Science', 'XII Commerce', 'XII Electrical', 'XII Civil', 'XII History','ITI ' ,'Diploma','PG (Postgraduate)','UG  (Undergraduate) '],
        English: [ 'VI', 'VII', 'VIII', 'IX', 'X', 'XI MathsBiology', 'XI Computer Science', 'XI Science', 'XI Commerce', 'XI Electrical', 'XI Civil', 'XI History', 'XII MathsBiology', 'XII Computer Science', 'XII Science', 'XII Commerce', 'XII Electrical', 'XII Civil', 'XII History','ITI ' ,'Diploma','PG (Postgraduate)','UG  (Undergraduate) ']
    };

  

    useEffect(() => {
    console.log("formData after update:", formData);
}, [formData]);



useEffect(() => {
  const { studentName, UserId, referralId, paymentState: passedPaymentState } = location.state || {};

  const savedName = sessionStorage.getItem("studentName");
  const savedUserId = sessionStorage.getItem("UserId");
  const savedReferralId = localStorage.getItem("UserId");

  const finalReferralId = referralId || savedReferralId || '';
  console.log("➡ Final referralId to set:", finalReferralId);

  setFormData(prev => ({
    ...prev,
    name: studentName || savedName || '',
    UserId: UserId || savedUserId || '',
    referralId: finalReferralId,
  }));

  if (passedPaymentState) {
    setPaymentState(passedPaymentState);
  }
}, [location.state]);


    
    console.log("location.state.referralId:", location.state.referralId);

    
    console.log('localStorage referralId:', localStorage.getItem('UserId'));
    console.log("location.state:", location.state);



    // Verify payment if orderId exists in URL
    useEffect(() => {
        const verifyPaymentIfNeeded = async () => {
            if (OrderId) {
                const token = await getAuthToken();
                if (token) await verifyPayment(OrderId, token);
            }
        };
        verifyPaymentIfNeeded();
    }, [OrderId]);

    const getAuthToken = async () => {
        try {
            const response = await axios.post(`https://ramjitrust.org:4000/payment/get-auth-token`);
            return response.data.access_token;
        } catch (error) {
            console.error("Error fetching auth token:", error);
            setMessage("Failed to initialize payment system");
            return null;
        }
    };

    const generateOrderId = () => {
        const timestamp = Date.now();
        const random = Math.floor(Math.random() * 10000);
        return `ORD_${timestamp}_${random}`.slice(0, 63);
    };

    const initiatePayment = async () => {
        // First validate form
        const requiredFields = ['name', 'fathername', 'school', 'medium', 'standard', 'bonafideImage', 'photoImage'];
        const missingFields = requiredFields.filter(field => !formData[field]);

        if (missingFields.length > 0) {
            setMessage(`Please fill all required fields: ${missingFields.join(', ')}`);
            return;
        }

        setLoading(true);
        try {
            const token = await getAuthToken();
            if (!token) return;

            const generatedOrderId = generateOrderId();
            setMerchantOrderId(generatedOrderId);
             // ✅ Build FormData
        const formDataToSend = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (value) formDataToSend.append(key, value);
        });
        formDataToSend.append("orderId", generatedOrderId); // Tag it

        // ✅ Save the full form with files before redirect
        await axios.post(`https://ramjitrust.org:4000/form/save-temp`, formDataToSend, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });


            const response = await axios.post(
                `https://ramjitrust.org:4000/payment/initiate-payment`,
                { 
                    amount: 70, 
                    merchantOrderId: generatedOrderId, 
                    token,
                   
                
                }
            );

            setPaymentUrl(response.data.redirectUrl);
            window.location.href = response.data.redirectUrl;
        } catch (error) {
            console.error("Payment initiation failed:", error);
            setMessage("Failed to initiate payment. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const verifyPayment = async (orderId, token) => {
        try {
            const res = await axios.post(`https://ramjitrust.org:4000/payment/verify-payment`, {
                orderId,
                token,
            });
            
            const state = res.data?.state;
            setPaymentState(state);

            if (state === "COMPLETED") {
                // If payment is complete, submit the form
                await submitForm();
                alert("✅ Payment Successful");
            } else if (state === "FAILED") {
                alert("❌ Payment Failed");
            } else if (state === "PENDING") {
                alert("⏳ Payment is still pending");
            }
        } catch (error) {
            console.error("Error verifying payment:", error);
            alert("❌ Could not verify payment.");
        }
    };

    const submitForm = async () => {
        setLoading(true);
        try {
            const formDataToSend = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value !== null && value !== undefined) {
                    formDataToSend.append(key, value);
                }
            });
    
            // Debug: Log form fields before sending
            console.log("🔍 Submitting form with the following data:");
            for (let pair of formDataToSend.entries()) {
                // console.log(`${pair[0]}:`, pair[1]);
            }
    
            const apiUrl = `${process.env.REACT_APP_API}/auth/register`;
            // console.log("🌐 API Endpoint:", apiUrl);
    
            const response = await axios.post(apiUrl, formDataToSend, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
    
            console.log("✅ Registration response:");
    
            if (response.status === 200 || response.status === 201) {
                setMessage(response.data.message || 'Registration successful!');
                console.log("🎉 Registration success!");
    
                // Reset form
                setFormData({
                    name: '',
                    fathername: '',
                    UserId: '',
                    school: '',
                    medium: '',
                    standard: '',
                    bonafideImage: null,
                    photoImage: null,
                    referralId:''
                });
            }
        } catch (error) {
            console.error("❌ Registration error:", error);
            console.error("📨 Error response:", error.response);
            setMessage(error.response?.data?.message || 'Registration failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: files ? files[0] : value
        }));
    };

    const handleMediumChange = (e) => {
        const medium = e.target.value;
        setFormData(prev => ({
            ...prev,
            medium,
            standard: '' // Reset standard when medium changes
        }));
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'PENDING': return 'orange';
            case 'FAILED': return 'red';
            case 'COMPLETED': return 'green';
            default: return 'gray';
        }
    };

    const standards = MediumtoStandard[formData.medium] || [];

    return (
        <div>
            <div style={{ marginBottom: '50px' }}>
                <Link to="/" className="logo_image">
                    <img src="assets/headimg.jpg" alt="Cleenhearts HTML" style={{ width: '100%' }} />
                </Link>
            </div>
            
            <section className="student-exam-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="exam-form-card">
                                <h2 className="text-center mb-4">Admin Exam Registration</h2>
                                
                                {message && (
                                    <div className={`alert ${message.includes('success') ? 'alert-success' : 'alert-danger'}`}>
                                        {message}
                                    </div>
                                )}

                                <form>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    placeholder="Full Name"
                                                    value={formData.name}
                                                    name="name"
                                                    onChange={handleChange}
                                                    required
                                                    readOnly
                                                />
                                                <label htmlFor="name">Student Name</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="fathername"
                                                    placeholder="Father's Name"
                                                    value={formData.fathername}
                                                    name="fathername"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <label htmlFor="fathername">Father's Name</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <select
                                                    id="medium"
                                                    name="medium"
                                                    className="form-control"
                                                    value={formData.medium}
                                                    onChange={handleMediumChange}
                                                    required
                                                >
                                                    <option value="">Select Medium</option>
                                                    {Object.keys(MediumtoStandard).map(medium => (
                                                        <option key={medium} value={medium}>{medium}</option>
                                                    ))}
                                                </select>
                                                <label htmlFor="medium">Medium</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <select
                                                    id="standard"
                                                    name="standard"
                                                    className="form-control"
                                                    value={formData.standard}
                                                    onChange={handleChange}
                                                    disabled={!formData.medium}
                                                    required
                                                >
                                                    <option value="">Select Standard</option>
                                                    {standards.map((standard, index) => (
                                                        <option key={index} value={standard}>{standard}</option>
                                                    ))}
                                                </select>
                                                <label htmlFor="standard">Standard</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="school"
                                                    placeholder="School / College"
                                                    value={formData.school}
                                                    name="school"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <label htmlFor="school">School/College</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="bonafideImage"
                                                    name="bonafideImage"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <label htmlFor="bonafideImage">Bonafide / ID Photo</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    id="photoImage"
                                                    name="photoImage"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <label htmlFor="photoImage">Upload Photo</label>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            {paymentState !== 'COMPLETED' ? (
                                                <button
                                                    type="button"
                                                    className="button"
                                                    onClick={initiatePayment}
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Processing...' : (
                                                        <>
                                                            <span>P</span>
                                                            <span>A</span>
                                                            <span>Y</span>
                                                            <span> </span>
                                                            <span>N</span>
                                                            <span>O</span>
                                                            <span>W</span>
                                                        </>
                                                    )}
                                                </button>
                                            ) : (
                                                <div className="payment-status">
                                                    Payment Status: 
                                                    <span style={{ 
                                                        color: getStatusColor(paymentState), 
                                                        fontWeight: 'bold' 
                                                    }}>
                                                        {paymentState}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <Footer />
        </div>
    );
};

export default AdminExam;





